import api from "shared/api";
import { User } from "shared/store/auth/types";
import { AxiosPromise } from "axios";

const prefix = "api/base";

export interface UserLoginStats extends User {
  last_login: Date;
  times_logged_in: number;
}

export interface WallpaperInfo {
  image_url: string;
  name: string;
  referral_url: string;
  unsplash_url: string;
}

export interface Link {
  link: string;
}

export const postRequestMagicLink = (
  email_address: string
): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/request-magic-link`, { email_address });
};

export const postProcessMagicLink = (token: string): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/process-magic-link`, { token });
};

export const postLoggedOut = (): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/logout`);
};

export const getUserLoginStats = async (): Promise<UserLoginStats[]> => {
  try {
    const res = await api().get<UserLoginStats[]>(`${prefix}/auth/stats`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getImpersonateLink = async (userId: number): Promise<Link> => {
  try {
    const res = await api().get<Link>(`${prefix}/auth/impersonate/${userId}`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getWallpaper = async (
  orientation: string
): Promise<WallpaperInfo> => {
  try {
    const res = await api().get<WallpaperInfo>(
      `${prefix}/wallpaper/${orientation}`
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};
